import { registerPlugin } from "@capacitor/core";

export interface TurnoNotificationPlugin {
  login(payload: { email: string; password: string }): Promise<void>;
  logout(): Promise<void>;
  startTurnoListener(payload: { userId: string }): Promise<void>;
}

export const TurnoNotificationPlugin = registerPlugin<TurnoNotificationPlugin>("TurnoNotificationPlugin");
